import React from 'react';
import paymobLogo from './../../../../../../../statics/img/esaypaisa/paymob.png';
import { CONSTANTS } from '../../constants';

export default function Footer() {
  return (
    <div className="halan_footer">
      <span>{CONSTANTS.FOOTER.TEXT}</span>
      <img src={paymobLogo} alt="Paymob" />
    </div>
  );
}
